  document.querySelectorAll('.product-faq .collapsible-row-header').forEach((button) => {
    button.addEventListener('click', () => {
      const content = button.nextElementSibling;
      const isOpen = content.style.display === 'block';
      content.style.display = isOpen ? 'none' : 'block';
      button.setAttribute('aria-expanded', !isOpen);

      const expandIcon = button.querySelector('[data-ingredients-accordion-expand]');
      const collapseIcon = button.querySelector('[data-ingredients-accordion-collapse]');

      if (isOpen) {
        if (expandIcon) expandIcon.style.display = 'block';
        if (collapseIcon) collapseIcon.style.display = 'none';
      } else {
        if (expandIcon) expandIcon.style.display = 'none';
        if (collapseIcon) collapseIcon.style.display = 'block';
      }
    });
  });